import React from 'react'

export default function ArrowStandIcon({ fillcolor, className, ...props }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.7812 7.04736L7.67663 3.94281L8.61943 3L13.3335 7.71403L8.61943 12.4281L7.67663 11.4853L10.7812 8.38069L4.66663 8.38083L4.66662 7.04749L10.7812 7.04736ZM2 12.3807V3.04734H3.33333V12.3807H2Z"
        fill={fillcolor || 'currentColor'}
      />
    </svg>
  )
}
